import { SvgIcon } from '@mui/material';
import React from 'react';

export default function WarrantyIcon({ ...props }) {
  return (
    <SvgIcon
      fill="none"
      height="48"
      viewBox="0 0 48 48"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_149_963)">
        <path
          d="M37.162 4.27999L24.632 0.101993C24.2217 -0.0346488 23.7783 -0.0346488 23.368 0.101993L10.838 4.27999C8.84581 4.94176 7.11283 6.21451 5.88529 7.91741C4.65775 9.62032 3.99808 11.6668 4 13.766V24C4 39.126 22.4 47.48 23.188 47.828C23.4436 47.9416 23.7203 48.0003 24 48.0003C24.2797 48.0003 24.5564 47.9416 24.812 47.828C25.6 47.48 44 39.126 44 24V13.766C44.0019 11.6668 43.3423 9.62032 42.1147 7.91741C40.8872 6.21451 39.1542 4.94176 37.162 4.27999ZM40 24C40 34.91 27.362 42.066 24 43.778C20.634 42.072 8 34.938 8 24V13.766C8.00012 12.5065 8.39655 11.2791 9.13313 10.2575C9.86972 9.23589 10.9091 8.47198 12.104 8.07399L24 4.10799L35.896 8.07399C37.0909 8.47198 38.1303 9.23589 38.8669 10.2575C39.6035 11.2791 39.9999 12.5065 40 13.766V24Z"
          fill="white"
        />
        <path
          d="M30.6 16.6L22.224 25L17.736 20.32C17.5559 20.1231 17.3382 19.9642 17.0957 19.8527C16.8533 19.7412 16.5909 19.6794 16.3242 19.6709C16.0575 19.6623 15.7917 19.7072 15.5426 19.803C15.2935 19.8987 15.0661 20.0434 14.8738 20.2284C14.6814 20.4134 14.528 20.635 14.4227 20.8802C14.3173 21.1254 14.2621 21.3892 14.2602 21.656C14.2584 21.9229 14.31 22.1874 14.412 22.4341C14.5139 22.6807 14.6642 22.9044 14.854 23.092L19.466 27.892C19.81 28.2635 20.2257 28.5614 20.688 28.7677C21.1504 28.9739 21.6498 29.0843 22.156 29.092H22.222C22.7181 29.0937 23.2096 28.9967 23.668 28.8069C24.1263 28.617 24.5424 28.338 24.892 27.986L33.436 19.442C33.6226 19.2558 33.7707 19.0347 33.8719 18.7912C33.973 18.5478 34.0252 18.2868 34.0255 18.0231C34.0258 17.7595 33.9741 17.4984 33.8735 17.2548C33.7729 17.0111 33.6252 16.7896 33.439 16.603C33.2528 16.4164 33.0317 16.2683 32.7882 16.1672C32.5448 16.066 32.2838 16.0138 32.0201 16.0136C31.7565 16.0133 31.4954 16.0649 31.2517 16.1655C31.0081 16.2662 30.7866 16.4138 30.6 16.6Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_149_963">
          <rect fill="white" height="48" width="48" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
